<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>
          {{ $t("turnosDeOperarios") }}
        </template>
      </breadcrumb>
      <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv"
        :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" :conFiltrarPorFecha="true" />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <!-- <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="changeNegocio()"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <label>&nbsp;</label>
              <div class="form-group">
                <button
                  v-if="!mostrarTurnos"
                  class="btn btn-primary"
                  @click="getSalesOperarios()"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="15"
                  />
                  {{ $t("consultar") }}
                </button>
                <button
                  v-else
                  class="btn btn-primary"
                  @click="turnosOperarios(idWorker)"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="15"
                  />
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <template v-else-if="respuesta">
        <div class="col-md-8">
          <div v-if="!mostrarTurnos" class="row justify-content-between div-export">

            <div class="row ms-xs">
              <div class="col-md-8">
                <div class="form-group d-flex justify-content-between">
                  <el-dropdown>

                    <el-button type="primary" size="small" class="mr-2">
                      <i class="fa fa-file"></i>
                      {{ $t("exportarInforme") }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <a :href="urlExportPDF">
                        <el-dropdown-item class="text-danger">
                          <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                        </el-dropdown-item>
                      </a>
                      <a :href="urlExportExcel">
                        <el-dropdown-item class="text-success">
                          <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                        </el-dropdown-item>
                      </a>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-button type="success" size="small" @click="openModalExternalLink">
                    <i class="fa fa-share"></i>
                    {{ $t("compartirEnlaceTurnos") }}
                  </el-button>
                  
                </div>
              </div>
            </div>
          </div>

          <template v-if="list.length > 0 && !mostrarTurnos">
            <div class="table-responsive">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr style="cursor: pointer">
                    <th v-if="ordenacionOperario === 0" @click="sortedArrayNameASC('workerName')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombre") }}
                    </th>
                    <th v-else @click="sortedArrayNameDESC('workerName')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombre") }}
                    </th>
                    <th v-if="ordenarDifHora === 0" @click="sortedArrayDifHoraASC('diffHora')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("horas") }}
                    </th>
                    <th v-else @click="sortedArrayDifHoraDESC('diffHora')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("horas") }}
                    </th>
                    <th v-if="ordenarSueldo === 0" @click="sortedArraySueldoASC('import')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("sueldo") }}
                    </th>
                    <th v-else @click="sortedArraySueldoDESC('import')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("sueldo") }}
                    </th>
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="obj in list">
                    <td>{{ obj.name }}</td>
                    <td>{{ obj.diffHora | timago }}</td>
                    <td class="text-right">
                      {{ (obj.import * (obj.diffHora / 60)) | currency }}
                    </td>
                    <td align="center">
                      <div class="btn btn-link">
                        <i v-if="obj.diffHora !== 0" @click="turnosOperarios(obj.idWorker)"
                          class="fas fa-arrow-circle-right" style="cursor: pointer" v-tooltip.top-center="$i18n.t('desgloseHorasTrabajadas')
                            "></i>
                      </div>
                      <div v-tooltip.top-center="'Exportar en PDF'" class="btn btn-link"
                        @click="exportGestionTurnosOperariosPDF(obj.idWorker)">
                        <i class="fas fa-file-pdf text-danger"></i>
                      </div>
                      <div v-tooltip.top-center="'Exportar en Excel'" class="btn btn-link"
                        @click="exportGestionTurnosOperariosExcel(obj.idWorker)">
                        <i class="fas fa-file-excel text-success"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td>
                      <strong v-if="getTotalHoras !== 0">{{
                        getTotalHoras | timago
                      }}</strong>
                    </td>
                    <td class="text-right">
                      {{ getTotalSueldos | currency }}<strong></strong>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-else-if="mostrarTurnos">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <button @click="volver()" class="btn btn-primary btn-sm">
                    <i class="fas fa-arrow-circle-left"></i>
                    {{ $t("volverAGeneral") }}
                  </button>
                </div>
                <div class="col-md-6">
                  <div class="text-right">
                    <el-dropdown>
                      <el-button type="primary" size="small">
                        <i class="fa fa-file"></i>
                        {{ $t("exportarInforme") }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <a :href="urlExportPDFById">
                          <el-dropdown-item class="text-danger">
                            <strong><i class="fa fa-file-pdf"></i>
                              {{ $t("exportarPdf") }}</strong>
                          </el-dropdown-item>
                        </a>
                        <a :href="urlExportExcelById">
                          <el-dropdown-item class="text-success">
                            <strong>
                              <i class="fa fa-file-excel"></i>
                              {{ $t("exportarExcel") }}
                            </strong>
                          </el-dropdown-item>
                        </a>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>

              <span style="font-size: 1.2em" v-if="listTurnos.length != 0">{{ $t("turnosDe") }} {{ listTurnos[0].name
                }}</span>
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("horaInicio") }}</th>
                      <th>{{ $t("horaFin") }}</th>
                      <th>{{ $t("horasTrabajadas") }}</th>
                      <th>{{ $t("sueldo") }}</th>
                      <th>{{ $t("observaciones") }}</th>
                      <th>{{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="t in listTurnos">
                      <td>{{ t.initDate | parseDateMin }}</td>
                      <td v-if="parseInt(t.endDate) === 0" class="text-success">
                        <strong>{{ $t("enActivo") }}</strong>
                      </td>
                      <td v-else>{{ t.endDate | parseDateMin }}</td>
                      <td>{{ t.diffHora | timago }}</td>
                      <td>{{ t.import | currency }}</td>
                      <td>
                        <span v-if="t.observaciones === ''" class="text-danger"><strong>{{ $t("noMayuscula")
                            }}</strong></span><span v-else class="text-success"><strong>{{ $t("siMayuscula")
                            }}</strong></span>
                      </td>
                      <td width="20%" height="20px">
                        <template v-if="t.observaciones !== ''">
                          <div class="btn btn-link">
                            <i @click="
                              (observacion = t.observaciones),
                              openModal(t.idWorkerDay)
                              " style="cursor: pointer" v-tooltip.top-center="$t('editarObservacion')"
                              class="fas fa-edit"></i>
                          </div>
                        </template>
                        <template v-else>
                          <div class="btn btn-link">
                            <i @click="
                              (observacion = ''), openModal(t.idWorkerDay)
                              " style="cursor: pointer" v-tooltip.top-center="$t('anadirObservacion')"
                              class="fas fa-plus-circle text-success"></i>
                          </div>
                        </template>

                        <div class="btn btn-link">
                          <i @click="
                            openModalEditarHora(
                              t.idWorkerDay,
                              t.initDate,
                              t.endDate
                            )
                            " v-tooltip.top-center="$t('editarHoraInicioYHoraFin')
                              " class="far fa-clock text-primary"></i>
                        </div>

                        <!--
                                            <div class="btn btn-link">
                                                <i @click="openModal(t.idWorkerDay,t.initDate,t.endDate)"
                                                  v-tooltip.top-center="'No mostrar este día en los informes'"
                                                  class="fas fa-eye-slash"></i>
                                            </div>
                                            -->
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-success">
                      <td>
                        <strong>{{ $t("total") }}</strong>
                      </td>
                      <td></td>
                      <td>
                        <strong v-if="getTotalHoras !== 0">{{
                          getTotalHorasWorker | timago
                        }}</strong>
                      </td>
                      <td>{{ getTotalSueldosWorker | currency }}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="alert alert-danger" role="alert">
              {{ $t("noHay") }} <strong>{{ $t("ventasPorOperarios") }}</strong>
              {{ $t("rangoDeFechas") }}
            </div>
          </template>
        </div>

        <div class="col-md-4 " v-show="this.list.length > 0">
          <div class="card">
            <div class="chart-container col-md-12 " style="height:40vh;">
              <canvas id="chart"></canvas>
            </div>
          </div>
        </div>
      </template>
    </div>

    <modal name="modal-agregar-observacion" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("anadirObservacion") }}</h4>
        </div>
        <div class="modal-body">
          <label for="observacion"><strong>{{ $t("observaciones") }}</strong></label>
          <textarea style="height: 300px" v-model="observacion" class="form-control" id="observacion">
      </textarea>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="changeObservaciones" class="btn btn-success">
              <i class="fas fa-plus-circle"></i>
              {{ $t("anadirObservacion") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="modal-editar-horario" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarHorario") }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label><strong>{{ $t("fechaInicio") }}</strong></label>
            <datetime zone="Europe/Madrid" :auto="true" type="datetime" class="theme-numier" :title="$t('fechaInicio')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="dd-MM-yyyy HH:mm"
              v-model="fechaInicio"></datetime>
          </div>

          <div class="form-group">
            <label><strong>{{ $t("fechaFin") }}</strong></label>
            <datetime zone="Europe/Madrid" :auto="true" type="datetime" class="theme-numier" :title="$t('fechaFin')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }" input-class="form-control" format="dd-MM-yyyy HH:mm"
              v-model="fechaFin"></datetime>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="changeHorarioTurno" class="btn btn-primary">
              <i class="fas fa-history"></i>
              {{ $t("editarHorarioDeTurno") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal external link turnos🔥 -->
    <modal name="modal-external-link" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("enlaceExternoTurnosTitle") }}</h4>
        </div>
        <div class="modal-body">
          <label><strong>{{ $t("enlaceExternoTurnosLabel") }}</strong>
          </label>

          <div class="input-group mb-3">
            <input type="text" class="form-control"
              :value="`https://www.numier.com/online/#/informes/operarios/turnos-operarios-external-link/${generatedHash}`"
              readonly />
            <button class="btn btn-outline-secondary"
              @click="copyToClipboard(`https://www.numier.com/online/#/informes/operarios/turnos-operarios-external-link/${generatedHash}`)">
              <i class="fas fa-copy"></i>
            </button>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="$modal.hide('modal-external-link')">
              <strong>{{ $t("cerrar") }}</strong>
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Loading,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import { mapState } from 'vuex'
import { Modal } from "bootstrap";
import { ModalPlugin } from "bootstrap-vue";

export default {
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      idBusiness: 0,
      list: ["-"],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      idTpv: 0,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenacionOperario: 0,
      ordenarImporte: 0,
      ordenarInvitations: 0,
      ordenarDifHora: 0,
      ordenarSueldo: 0,

      observacion: "",

      //TURNOS
      mostrarTurnos: false,
      listTurnos: [],
      idWorker: 0,

      idWorkerDay: 0,
      respuesta: true,
      filtrarPorFecha: false,

      fechaInicio: new Date().toISOString(),
      fechaFin: new Date().toISOString(),

      createdDate: new Date().toISOString(),
      expiredDate: new Date(Date.now() + 5 * 60 * 60 * 1000).toISOString(), // +5 horas
      generatedHash: "",
    };
  },
  computed: {
    ...mapState(["permiso"]),
    getTotalSueldos() {
      let total = 0;
      this.list.forEach(function (d) {
        if (d.import > 0) {
          total += d.import * (d.diffHora / 60);
        }
      });
      return total;
    },
    getTotalHoras() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    getTotalHorasWorker() {
      let total = 0;
      this.listTurnos.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    getTotalSueldosWorker() {
      var total = 0;
      this.listTurnos.forEach(function (d) {
        if (d.import > 0) {
          total += d.import;
        }
      });
      return total;
    },
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    urlExportPDFById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/PDF?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha=" +
        this.filtrarPorFecha +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("turnosDeOperarios"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    CabeceraInformes,
    Breadcrumb,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  methods: {
    cambioBusiness(idBusinessData, listTpv = null) {
      this.idBusiness = idBusinessData;
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.idTpv = -1;
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },
    emitirConsulta(filtrarPorFecha) {
      this.getSalesOperarios(filtrarPorFecha);
    },
    cambioTpv(idTpvData, filtrarPorFecha) {
      this.idTpv = idTpvData;

      if (this.idWorker != 0 && this.mostrarTurnos == true) {
        //this.turnosOperarios(this.idWorker);
        this.mostrarTurnos = false;
      }
      this.getSalesOperarios(filtrarPorFecha);
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    sortedArrayWorkerDay: function () {
      function compare(a, b) {
        if (a.initDate < b.initDate) return -1;
        if (a.initDate > b.initDate) return 1;
        return 0;
      }

      return this.listTurnos.sort(compare);
    },

    openModal(idWorkerDay) {
      this.$modal.show("modal-agregar-observacion");

      this.idWorkerDay = idWorkerDay;
    },

    openModalEditarHora(idWorkerDay, initDate, endDate) {
      this.$modal.show("modal-editar-horario");

      this.idWorkerDay = idWorkerDay;

      this.fechaInicio = moment.unix(initDate).toISOString();

      if (endDate !== "0") {
        this.fechaFin = moment.unix(endDate).toISOString();
      } else {
        this.fechaFin = newDate().toIsoString();
      }
    },

    sortedArrayNameASC: function () {
      this.ordenacionOperario = 1;

      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayNameDESC: function () {
      this.ordenacionOperario = 0;

      function compare(a, b) {
        if (a.name > b.name) return -1;
        if (a.name < b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayDifHoraASC: function () {
      this.ordenarDifHora = 1;

      function compare(a, b) {
        if (a.diffHora < b.diffHora) return -1;
        if (a.diffHora > b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayDifHoraDESC: function () {
      this.ordenarDifHora = 0;

      function compare(a, b) {
        if (a.diffHora > b.diffHora) return -1;
        if (a.diffHora < b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArraySueldoASC: function () {
      this.ordenarSueldo = 1;

      function compare(a, b) {
        if (a.import < b.import) return -1;
        if (a.import > b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArraySueldoDESC: function () {
      this.ordenarSueldo = 0;

      function compare(a, b) {
        if (a.import > b.import) return -1;
        if (a.import < b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    turnosOperarios(idWorker) {
      this.idWorker = idWorker;

      this.mostrarTurnos = true;

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idTpv: this.idTpv,
              idBusiness: this.idBusiness,
              idWorker: idWorker,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
              filtrarFecha: this.filtrarPorFecha
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "workers/getWorkersDay", config)
            .then(function (response) {
              if (response.data.response) {
                vm.listTurnos = response.data.result;

                vm.sortedArrayWorkerDay();
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    changeNegocio() { },

    volver() {
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
            vm.idTpv = -1;
          }
          vm.cambioTpv(-1, false)
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally((_) => {
          this.loading.close();
        });
    },
    getSalesOperarios(filtrarPorFecha) {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              filtrarPorFecha: filtrarPorFecha,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
              desde: 0,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "workers/getTurnosOperarios",
              config
            )
            .then(function (response) {
              if (response.data.response) {
                vm.list = response.data.result;

                vm.respuesta = true;
                vm.filtrarPorFecha = filtrarPorFecha;

                vm.initChart();
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },

    changeObservaciones() {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };
      var params = {
        observaciones: this.observacion,
        idWorkerDay: this.idWorkerDay,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateObservacionesByIdWorkerDay";
      this.axios
        .post(
          this.$store.getters.apiUrl + "workers/" + controller,
          params,
          config
        )
        .then(function (response) {
          vm.inProgress = false;

          if (response.data.response) {
            let notify = vm.$t("actualizada");
            vm.$notify({
              message:
                vm.$t("observacion") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.turnosOperarios(vm.idWorker);

            vm.$modal.hide("modal-agregar-observacion");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    changeHorarioTurno() {
      let secondsDesde = moment(this.fechaInicio).unix();
      let secondsHasta = moment(this.fechaFin).unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };
        var params = {
          datefrom: secondsHasta,
          dateto: secondsDesde,
          idWorkerDay: this.idWorkerDay,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "updateHorarioByIdWorkerDay";
        this.axios
          .post(
            this.$store.getters.apiUrl + "workers/" + controller,
            params,
            config
          )
          .then(function (response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("actualizada");
              vm.$notify({
                message:
                  vm.$t("observacion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.turnosOperarios(vm.idWorker);

              vm.$modal.hide("modal-editar-horario");
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    exportGestionTurnosOperariosExcel(idWorker) {
      // window.location.href = "../api/public/index.php/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&idWorker=" + idWorker + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;

      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;
    },
    exportGestionTurnosOperariosPDF(idWorker) {
      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/PDF?idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;
    },

    initChart() {
      var labels = this.list.map(function (x) {
        return x.name;
      });

      var data = this.list.map(function (x) {
        var hours = Math.floor(x.diffHora / 60);
        var minutes = Math.floor(x.diffHora % 60);

        return hours + minutes / 100;
      });

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador === 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "bar",
            data: {
              labels: labels,
              datasets: [
                {
                  label: this.$t("horasTrabajadas"),
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },

              responsive: true,
              maintainAspectRatio: false,
            },
          });

          this.contador++;
        }
      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                label: this.$t("turnosOperarios"),
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }
    },
    openModalExternalLink() {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      var params = {
        idBusiness: this.idBusiness,
        idTpv: this.idTpv,
        createdDate: Math.floor(Date.now() / 1000), // Timestamp actual en segundos
        datefrom: moment(this.datefrom).startOf("day").unix(),
        dateto: moment(this.dateto).endOf("day").unix(),
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "generateExternalLinkTurnosOperarios";
      //this.loading = Loading.service({ text: "Cargando..." });
      //vm.loading.close();

      this.axios
        .post(
          this.$store.getters.apiUrl + "workers/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.success) {
            vm.generatedHash = response.data.hash;
            vm.$modal.show("modal-external-link");

            vm.$notify({
              message: vm.$t("enlaceGeneradoExito"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("ups"),
              text: vm.$t("noSeHaPodidoGenerarElEnlace"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.error("Error al generar el enlace externo:", error);

          swal({
            title: vm.$t("ups"),
            text: vm.$t("errorComunicacionBackend"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$notify({
          title: this.$t("enlaceCopiadoAlPortapapeles"),
          horizontalAlign: "center",
          type: "success",
        });
      });
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.textNumier {
  color: #1E22AA;
}

.ms-xs {
  margin-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/TurnosOperarios.vue